/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import dynamic from 'next/dynamic';
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import '../../libs/aemComponents/Container';
import clsx from 'clsx';
import {
  EditableHTLWrapper,
  StaticWrapper,
  CardHorizontalMini,
  CardCarouselContainer,
  CardHorizontalFeature,
  CardLayered,
  CardVertical,
  Mosaic,
  RichText,
  BannerLayered,
  LinkList,
  AccordionContainer,
  BrandRibbon,
  IconBlock,
  CobrandCardHorizontalFlexible,
  LinkBanner,
  GeneralMessage,
  BannerText,
  DataBlock,
  Hero,
  VariableColumnContainer,
  MiniCardCarouselContainer,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  CarouselGallery,
  Text,
  AccordionContainerEnhanced,
  BannerFeature,
  TabContainer,
  Media,
  CardSummary,
  Footer,
} from '@marriott/mi-common-static-components';
import { OfferCardCarousel } from '@marriott/mi-offers-components';
import {
  CardCarouselResorts,
  TabComponentContainer,
  MiniCardCarouselContainer as LeisureMiniCardCarouselContainer,
  HtmlSitemap,
  PropertiesList,
  Breadcrumb,
  DestinationOverview,
  DestinationLinksIconCardCarousel,
  DestinationHero,
  ExperienceFragmentDestinationHero,
} from '@marriott/mi-leisure-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { SearchFormEditable } from '@marriott/mi-shop-components';

import { MerchandisingSmallBanner } from '@marriott/mi-merch-components';
import { DynamicPropertyCardCarouselMockData } from './specs/__mock__/carouselMockData.mock';

const FooterDynamic = dynamic(() => import('@marriott/mi-common-static-components').then(module => module.Footer), {
  ssr: true,
});

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/mosaic`]: Mosaic,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/iconblock`]: IconBlock,
  [`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`]: CobrandCardHorizontalFlexible,
  [`mi-aem-common-spa/components/content/linkbanner`]: LinkBanner,
  [`mi-aem-common-spa/components/content/generalmessage`]: GeneralMessage,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-common-spa/components/content/bannertext`]: BannerText,
  [`mi-aem-common-spa/components/content/datablock`]: DataBlock,
  [`mi-aem-common-spa/components/content/merchandisingsmallbanner`]: MerchandisingSmallBanner,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/content/variablecolumncontainer`]: VariableColumnContainer,

  [`mi-aem-common-spa/components/content/carouselgallery`]: CarouselGallery,
  [`mi-aem-common-spa/components/content/text`]: Text,
  [`mi-aem-common-spa/components/content/accordioncontainerenhanced`]: AccordionContainerEnhanced,
  [`mi-aem-common-spa/components/content/bannerfeature`]: BannerFeature,
  [`mi-aem-common-spa/components/content/tabcontainer`]: TabContainer,
  [`mi-aem-common-spa/components/content/media`]: Media,
  [`mi-aem-common-spa/components/content/cardsummary`]: CardSummary,

  [`mi-aem-offers-spa/components/offers-cards`]: OfferCardCarousel,

  [`mi-aem-leisure-spa/components/leisure-searchform`]: SearchFormEditable,
  [`mi-aem-leisure-spa/components/card-mini-carousel-container`]: LeisureMiniCardCarouselContainer,
  [`mi-aem-common-spa/components/content/card-mini-carousel-container`]: MiniCardCarouselContainer,
  [`mi-aem-leisure-spa/components/cardCarouselResorts`]: CardCarouselResorts,
  [`mi-aem-leisure-spa/components/tabbedNavigationMenu`]: TabComponentContainer,
  [`mi-aem-leisure-spa/components/htmlsitemap`]: HtmlSitemap,
  [`mi-aem-leisure-spa/components/dynamicPropertyCardCarousel`]: Container,
  [`mi-aem-leisure-spa/components/propertiesList`]: PropertiesList,
  [`mi-aem-leisure-spa/components/leisureBreadcrumb`]: Breadcrumb,
  [`mi-aem-leisure-spa/components/destinationOverview`]: DestinationOverview,
  [`mi-aem-leisure-spa/components/leisureTabContainer`]: TabContainer,
  [`mi-aem-leisure-spa/components/iconCardCarousel`]: DestinationLinksIconCardCarousel,
  [`mi-aem-leisure-spa/components/destinationshero`]: DestinationHero,
  [`mi-aem-leisure-spa/components/experienceFragmentDestinationHero`]: ExperienceFragmentDestinationHero,

  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
};

export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  pageProps,
  leisureCarouselFeatureFlags
) => {
  const { resolvedUrl } = pageProps ?? {};
  const isResorts = resolvedUrl?.includes('resorts');
  const isDestinations = resolvedUrl?.includes('destinations');
  const searchTypeClass = isResorts ? 'resorts-search' : isDestinations ? 'destinations-search' : '';

  const { carousel_switch_leisure = false } = leisureCarouselFeatureFlags;
  const leisureCarouselFromLightning =
    (pageProps?.query?.lightning === 'true' || carousel_switch_leisure === true) &&
    !pageProps?.requestUri?.includes('/preview');

  const destinationColStyleOverride = isResorts ? false : isDestinations ? true : false;
  MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
  MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(props => (
    <div className="card-horizontal-feature-wrapper">
      <CardHorizontalFeature {...props} />
    </div>
  ));
  MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);
  MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
  MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
  MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
  MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
  MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
    <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/brandribbon`)(BrandRibbon);
  MapTo(`mi-aem-common-spa/components/content/iconblock`)(IconBlock);
  MapTo(`mi-aem-common-spa/components/content/cobrandcardhorizontalflexible`)(CobrandCardHorizontalFlexible);
  MapTo(`mi-aem-common-spa/components/content/linkbanner`)(LinkBanner);
  MapTo(`mi-aem-common-spa/components/content/generalmessage`)(GeneralMessage);
  MapTo(`mi-aem-common-spa/components/content/hero`)(props => (
    <div className={`${props?.model?.styleclass ?? ''}`}>
      <Hero {...props} />
    </div>
  ));
  MapTo(`mi-aem-common-spa/components/content/bannertext`)(BannerText);
  MapTo(`mi-aem-common-spa/components/content/datablock`)(DataBlock);
  MapTo(`mi-aem-common-spa/components/content/variablecolumncontainer`)(props => (
    <VariableColumnContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
    <CardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/mosaic`)(Mosaic);

  const ExperienceFragmentVariationConfig = {
    emptyLabel: 'Experience Fragment',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  // Added this mapping, to pass in the classNames via Style class Model object.
  MapTo(`mi-aem-common-spa/components/experiencefragment`)(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
        className={props?.model?.styleclass}
      />
    );
  }, ExperienceFragmentVariationConfig);

  MapTo(`mi-aem-common-spa/components/content/merchandisingsmallbanner`)(
    props => <MerchandisingSmallBanner {...props} isAuthorMode={isAuthorMode} />,
    {
      emptyLabel: 'MerchandesingSmallBanner',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/card-mini-carousel-container`)(
    props => {
      return (
        <div className={`${props?.model?.styleclass ?? ''}`}>
          <MiniCardCarouselContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
        </div>
      );
    },
    {
      isEmpty: true,
    }
  );
  MapTo(`mi-aem-common-spa/components/content/carouselgallery`)(CarouselGallery);
  MapTo(`mi-aem-common-spa/components/content/cardsummary`)(CardSummary);
  MapTo(`mi-aem-common-spa/components/content/text`)(props => <Text {...props} />);
  MapTo(`mi-aem-common-spa/components/content/bannerfeature`)(props => <BannerFeature {...props} />);
  MapTo(`mi-aem-common-spa/components/content/tabcontainer`)(props => (
    <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/media`)(props => (
    <Media {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-common-spa/components/content/accordioncontainerenhanced`)(props => (
    <AccordionContainerEnhanced {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-offers-spa/components/offers-cards`)(props => (
    <div className={`${props?.model?.styleclass ?? ''}`}>
      <OfferCardCarousel
        {...props}
        offersData={pageProps?.productSpecificResponse}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.headersData['accept-language']}
        requestId={pageProps?.requestId}
        cookie={pageProps?.headersData['cookie']}
        DestinationDetails={pageProps?.model?.destinationMetaData}
        isLightning={leisureCarouselFromLightning}
      />
    </div>
  ));

  MapTo(`mi-aem-leisure-spa/components/experienceFragmentDestinationHero`)(props => (
    <ExperienceFragmentDestinationHero {...props} />
  ));
  MapTo(`mi-aem-leisure-spa/components/leisure-searchform`)(
    props => {
      return (
        <div className={`${props?.model?.styleclass ?? 'standard'} ${searchTypeClass}`}>
          <SearchFormEditable
            {...props}
            isAuthorMode={isAuthorMode}
            currentLocale={pageProps.currentLocale}
            destinationColStyleOverride={destinationColStyleOverride}
          />
        </div>
      );
    },
    {
      emptyLabel: 'SearchForm',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-leisure-spa/components/card-mini-carousel-container`)(
    props => {
      return (
        <div className={`${props?.model?.styleclass ?? ''}`}>
          <LeisureMiniCardCarouselContainer
            {...props}
            isAuthorMode={isAuthorMode}
            allowedComponents={allowedComponents}
          />
        </div>
      );
    },
    {
      isEmpty: true,
    }
  );
  MapTo(`mi-aem-leisure-spa/components/cardCarouselResorts`)(props => (
    <div className={`${props?.model?.styleclass ?? ''}`}>
      <CardCarouselResorts
        {...props}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.headersData['accept-language']}
        requestId={pageProps?.requestId}
        subDirectoryContextPath={pageProps?.model?.subDirectoryContextPath}
        isDTT={pageProps?.isDTT}
      />
    </div>
  ));
  MapTo(`mi-aem-leisure-spa/components/tabbedNavigationMenu`)(
    props => {
      return (
        <div className={`${props?.model?.styleclass ?? ''}`}>
          <TabComponentContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
        </div>
      );
    },
    {
      emptyLabel: 'TabComponentContainer',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-leisure-spa/components/htmlsitemap`)(
    props => {
      return <HtmlSitemap {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />;
    },
    {
      emptyLabel: 'HtmlSitemap',
      isEmpty: false,
    }
  );

  const DynamicPropertyCardCarouselConfig = {
    emptyLabel: 'DynamicPropertyCardCarousel',

    isEmpty: function (props) {
      return !props || !props.configured;
    },
  };
  MapTo(`mi-aem-leisure-spa/components/dynamicPropertyCardCarousel`)(props => {
    return (
      <Container
        isInEditor
        {...props}
        isPage={false}
        model={
          !isAuthorMode
            ? respGridUtil(props?.model)
            : respGridUtil(DynamicPropertyCardCarouselMockData.dynamicpropertycardc)
        }
        className={clsx(`dynamic-prop-card-carousel ${props?.model?.styleclass}`)}
      />
    );
  }, DynamicPropertyCardCarouselConfig);
  MapTo(`mi-aem-leisure-spa/components/propertiesList`)(props => (
    <div className={`${props?.model?.styleclass ?? ''}`}>
      <PropertiesList
        {...props}
        isAuthorMode={isAuthorMode}
        acceptLanguage={pageProps?.headersData['accept-language']}
        requestId={pageProps?.requestId}
        destinationMetaData={pageProps?.model?.destinationMetaData}
        subDirectoryVal={pageProps?.model?.subDirectoryContextPath}
        sessionData={pageProps?.sessionData}
        isDTT={pageProps?.isDTT}
        currentLocale={pageProps.currentLocale}
      />
    </div>
  ));

  MapTo(`mi-aem-leisure-spa/components/leisureBreadcrumb`)(
    props => {
      return <Breadcrumb {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />;
    },
    {
      emptyLabel: 'Breadcrumb',
      isEmpty: false,
    }
  );
  MapTo(`mi-aem-leisure-spa/components/destinationOverview`)(props => (
    <div className={`${props?.model?.styleclass ?? ''}`}>
      <DestinationOverview {...props} isAuthorMode={isAuthorMode} />
    </div>
  ));
  MapTo(`mi-aem-leisure-spa/components/leisureTabContainer`)(props => (
    <TabContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
  ));
  MapTo(`mi-aem-leisure-spa/components/iconCardCarousel`)(
    props => {
      return (
        <DestinationLinksIconCardCarousel
          {...props}
          isAuthorMode={isAuthorMode}
          allowedComponents={allowedComponents}
        />
      );
    },
    {
      emptyLabel: 'DestinationLinksIconCardCarousel',
      isEmpty: false,
    }
  );

  MapTo(`mi-aem-leisure-spa/components/destinationshero`)(props => (
    <DestinationHero {...props} allowedComponents={allowedComponents} />
  ));

  MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(
    props => <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />,
    { emptyLabel: 'NavigationContainerWrapper', isEmpty: false }
  );
  MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper, {
    emptyLabel: 'NavigationUtilityLinkWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper, {
    emptyLabel: 'NavigationWrapper',
    isEmpty: false,
  });
  MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(props =>
    isAuthorMode ? (
      <Footer {...props} isAuthorMode={isAuthorMode} />
    ) : (
      <FooterDynamic {...props} isAuthorMode={isAuthorMode} />
    )
  );

  const existingMappings = Object.keys(AEM_REACT_MAPPING);
  if (allowedComponents) {
    allowedComponents.forEach(mapping => {
      const baseModelPath = '/jcr:content/root/responsivegrid/';
      const componentPath = mapping.path.split(baseModelPath)[1];

      if (existingMappings.indexOf(componentPath) === -1) {
        MapTo(componentPath)(EditableHTLWrapper, {
          emptyLabel: mapping.title,
          isEmpty: false,
        });
      } else {
        console.log('mapping exists', componentPath);
      }
    });
  }
};
